module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/point02_sp-7081919431947f7af6d1141694aeb7e3.png";